/* =====================================================================
 * Pack switcher — winning A/B test variant, now a theme feature.
 * ---------------------------------------------------------------------
 * The markup and all product data (variants, colours, sizes, offer
 * tiers, default size) are rendered server-side by
 * snippets/pack-switcher.liquid; this script only adds the behaviour:
 * tier switching, per-item customisation, availability handling,
 * SmartSize™ integration, gallery sync and add-to-cart.
 * ===================================================================== */
(function () {
  'use strict';

  if (window.__packSwitcherTheme) return;
  window.__packSwitcherTheme = true;

  var VERSION = 'liquid-v2-fr-cadeau-maquette';

  /* Cadeau et livraison offerts (maquette du 16/10/2026) : icônes des cartes et de l'encadré. */
  var ICON_TRUCK = '<svg class="ps-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>';
  var ICON_GIFT = '<svg class="ps-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"/></svg>';

  function log() { try { console.log.apply(console, ['[pack-switcher ' + VERSION + ']'].concat([].slice.call(arguments))); } catch (e) {} }

  /* --------------------------- HELPERS ------------------------------ */
  /* IT + FR + DE + EN colour names -> hex. Longer keys are matched first
     (see COLOR_KEYS) so "blu chiaro" wins over "blu", "vert armée" over
     "vert". The IT store also has one product whose colour option is still
     named in French (calzini "Couleur"), hence the FR names stay. */
  var COLOR_MAP = {
    // ----- Italian -----
    'bianco': '#ffffff', 'nero': '#1a1a1a',
    'blu chiaro': '#a9cce3', 'azzurro': '#a9cce3', 'celeste': '#a9cce3',
    'blu navy': '#1f3a5f', 'blu marino': '#1f3a5f', 'blu scuro': '#1f3a5f', 'blu': '#2563eb',
    // "Grigi" (Plural) steht so auf den Socken — ohne eigenen Eintrag fiele
    // es still auf das Ersatzgrau zurueck.
    'grigio chiaro': '#c9ccd1', 'grigio scuro': '#565a5e', 'grigio': '#9e9e9e', 'grigi': '#9e9e9e',
    'rosso': '#7d2733', 'bordeaux': '#7d2733',
    'turchese': '#2b7a87',
    'verde militare': '#4a5d23', 'verde oliva': '#4a5d23', 'oliva': '#4a5d23',
    'verde salvia': '#616c54', 'salvia': '#616c54',
    'cachi': '#8f8b66', 'verde': '#16a34a', 'giallo': '#facc15', 'marrone': '#4b4138',
    // ----- French -----
    'blanc': '#ffffff', 'noir': '#1a1a1a',
    'bleu clair': '#a9cce3', 'bleu marine': '#1f3a5f', 'bleu ciel': '#a9cce3', 'marine': '#1f3a5f', 'bleu': '#2563eb',
    'gris clair': '#c9ccd1', 'gris foncé': '#565a5e', 'gris fonce': '#565a5e', 'gris': '#9e9e9e',
    'rouge': '#7d2733',
    'turquoise': '#2b7a87',
    'vert armée': '#4a5d23', 'vert armee': '#4a5d23', 'vert militaire': '#4a5d23', 'kaki': '#8f8b66', 'olive': '#4a5d23', 'sauge': '#616c54', 'sage': '#616c54',
    'vert': '#16a34a',
    'jaune': '#facc15', 'marron': '#4b4138', 'brun': '#4b4138',
    // ----- German -----
    'weiß': '#ffffff', 'weiss': '#ffffff',
    'schwarz': '#1a1a1a',
    'hellblau': '#a9cce3', 'dunkelblau': '#1f3a5f', 'marineblau': '#1f3a5f', 'navy': '#1f3a5f', 'blau': '#2563eb',
    'hellgrau': '#c9ccd1', 'dunkelgrau': '#565a5e', 'grau': '#9e9e9e',
    'rosa': '#f4b8d0', 'rose': '#f4b8d0',
    'weinrot': '#7d2733', 'rot': '#7d2733',
    'türkis': '#2b7a87', 'tuerkis': '#2b7a87',
    'armeegrün': '#4a5d23', 'armeegruen': '#4a5d23', 'oliv': '#4a5d23', 'olivgrün': '#4a5d23', 'olivgruen': '#4a5d23',
    'grün': '#16a34a', 'gruen': '#16a34a',
    'khaki': '#8f8b66', 'gelb': '#facc15', 'beige': '#c2a788', 'braun': '#6f4e37',
    // ----- English -----
    'white': '#ffffff', 'black': '#1a1a1a', 'grey': '#9e9e9e', 'gray': '#9e9e9e',
    'light blue': '#a9cce3', 'dark blue': '#1f3a5f', 'blue': '#2563eb',
    'red': '#7d2733', 'green': '#16a34a', 'army green': '#4a5d23', 'olive green': '#4a5d23',
    'brown': '#C5A383', 'yellow': '#facc15', 'pink': '#f4b8d0'
  };
  var COLOR_KEYS = Object.keys(COLOR_MAP).sort(function (a, b) { return b.length - a.length; });

  /* Per-product swatch overrides. Set on the pack switcher block in the theme
     editor ("Swatch overrides") and handed over by the Liquid data island.
     Keys are colour names, values either a CSS colour or an image URL. They
     win over COLOR_MAP, so a product can give "Beige" its own shade without
     touching the shared palette. Module-level because a product page renders
     exactly one pack switcher and the swatch helpers below are shared
     instance-free utilities. */
  var SWATCH_OVERRIDES = {};
  function setSwatchOverrides(map) {
    if (!map) return;
    Object.keys(map).forEach(function (k) {
      var v = String(map[k] == null ? '' : map[k]).trim().replace(/^["']|["']$/g, '').trim();
      if (!v) return;
      // Stored twice: under the literal option value, so "Blanc (Poche)" can be
      // given its own swatch without touching plain "Blanc", and under the
      // normalised name as the looser fallback.
      SWATCH_OVERRIDES[String(k).trim().toLowerCase()] = v;
      SWATCH_OVERRIDES[swatchKey(k)] = v;
    });
  }
  /* Loose lookup key: normalised name, with the pocket variant kept apart so
     "Blanc (Poche)" and "Blanc Poche" mean the same swatch — and neither of
     them bleeds into plain "Blanc". */
  function swatchKey(name) { return normColorName(name) + (isPocketColor(name) ? '::pocket' : ''); }
  function overrideFor(name) {
    var raw = String(name || '').trim().toLowerCase();
    if (Object.prototype.hasOwnProperty.call(SWATCH_OVERRIDES, raw)) return SWATCH_OVERRIDES[raw];
    var key = swatchKey(name);
    return Object.prototype.hasOwnProperty.call(SWATCH_OVERRIDES, key) ? SWATCH_OVERRIDES[key] : null;
  }
  function isImageValue(v) {
    return /^(https?:)?\/\//.test(v) || /^\/[^\s]*\.(png|jpe?g|webp|gif|svg|avif)/i.test(v) || /\.(png|jpe?g|webp|gif|svg|avif)(\?|$)/i.test(v);
  }

  /* Colour names carry a "pocket" qualifier on one white variant
     ("Weiß (Tasche)" / "Blanc (Poche)"). Strip it before resolving the hex so
     both whites map to white — the little pocket icon is what tells them apart. */
  function isPocketColor(name) { return /\b(tasche|poche|pocket)\b/i.test(String(name || '')); }
  function normColorName(name) {
    return String(name || '').trim().toLowerCase()
      .replace(/[()]/g, ' ')
      .replace(/\b(tasche|poche|pocket)\b/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }
  function swatchColor(name) {
    var raw = String(name || '').trim().toLowerCase();
    var key = normColorName(name);
    // A colour override replaces the palette outright; an image override keeps
    // the palette colour underneath (backdrop + pocket icon contrast).
    var ov = overrideFor(name);
    if (ov && !isImageValue(ov)) return ov;
    if (COLOR_MAP[key]) return COLOR_MAP[key];
    if (COLOR_MAP[raw]) return COLOR_MAP[raw];
    for (var i = 0; i < COLOR_KEYS.length; i++) {
      var k = COLOR_KEYS[i];
      if (key === k || key.indexOf(k) > -1 || raw.indexOf(k) > -1) return COLOR_MAP[k];
    }
    var test = new Option().style; test.color = ''; test.color = key || raw;
    return test.color !== '' ? (key || raw) : '#cccccc';
  }
  /* Readable stroke colour for the pocket icon, based on swatch luminance. */
  function readableOn(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec(hex || '');
    if (!m) return '#333';
    var n = parseInt(m[1], 16), r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
    return (0.299 * r + 0.587 * g + 0.114 * b) > 150 ? '#333' : '#fff';
  }
  /* Little shirt-pocket glyph overlaid on the pocket colour's swatch. */
  function pocketIcon(colorName) {
    var stroke = readableOn(swatchColor(colorName));
    return '<svg class="ps-pocket" viewBox="0 0 24 24" fill="none" stroke="' + stroke + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 8h12v8.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 16.5z"></path><path d="M6 8l6 4 6-4"></path></svg>';
  }
  function swatchInner(colorName) { return isPocketColor(colorName) ? pocketIcon(colorName) : ''; }
  /* Inline background for one swatch: the resolved colour, plus the override
     image on top when one is configured, so a broken image still shows a colour. */
  function swatchCss(colorName) {
    var css = 'background-color:' + swatchColor(colorName) + ';';
    var ov = overrideFor(colorName);
    if (ov && isImageValue(ov)) {
      css += "background-image:url('" + ov.replace(/['"\\)]/g, '') + "');" +
             'background-size:cover;background-position:center;background-repeat:no-repeat;';
    }
    return css;
  }
  function formatMoney(cents, currency) {
    try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: currency || 'EUR' }).format((cents || 0) / 100); }
    catch (e) { return ((cents || 0) / 100).toFixed(2); }
  }
  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Size-token matching (same approach as cro-bundle-size-defaults.liquid) so a
     token like "44" matches an option like "44 (XL)". */
  function normSize(s) { return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ß/g, 'ss').replace(/\s+/g, ' ').trim(); }
  function tokSize(s) { return normSize(s).replace(/[()]/g, ' ').split(/[\s/]+/).filter(Boolean); }
  function scoreSize(option, target) {
    var o = normSize(option), t = normSize(target);
    if (o === t) return 3;
    if (tokSize(option).indexOf(t) !== -1) return 2;
    if (t.length >= 3 && o.indexOf(t) !== -1) return 1;
    return 0;
  }
  function matchSizeToken(sizes, token) {
    if (!token) return null;
    var best = null, bs = 0;
    sizes.forEach(function (s) { var sc = scoreSize(s, token); if (sc > bs) { bs = sc; best = s; } });
    return bs > 0 ? best : null;
  }

  /* ------------------------- CORE LOGIC ----------------------------- */
  function PackSwitcher(root, data) {
    this.root = root;
    this.data = data;
    if (!this.data) return;
    setSwatchOverrides(this.data.swatchOverrides);

    this.variantByKey = {};
    this.data.variants.forEach(function (v) { this.variantByKey[v.color + '||' + v.size] = v; }, this);

    this.els = {
      sizeSelect: root.querySelector('[data-ps-size-select]'),
      colors: root.querySelector('[data-ps-colors]'),
      colorCurrent: root.querySelector('[data-ps-color-current]'),
      colorProgress: root.querySelector('[data-ps-color-progress]'),
      tiers: root.querySelector('[data-ps-tiers]'),
      qty: root.querySelector('[data-ps-qty]'),
      slots: root.querySelector('[data-ps-slots]'),
      perks: root.querySelector('[data-ps-perks]'),
      total: root.querySelector('[data-ps-total]'),
      totalWas: root.querySelector('[data-ps-total-was]'),
      totalSave: root.querySelector('[data-ps-total-save]'),
      perunit: root.querySelector('[data-ps-perunit]'),
      atc: root.querySelector('[data-ps-atc]'),
      atcSpinner: root.querySelector('.ps-atc__spinner'),
      message: root.querySelector('[data-ps-message]'),
      modal: root.querySelector('[data-ps-modal]'),
      modalTitle: root.querySelector('[data-ps-modal-title]'),
      modalColors: root.querySelector('[data-ps-modal-colors]'),
      modalSizes: root.querySelector('[data-ps-modal-sizes]')
    };

    if (this.els.modal && this.els.modal.parentNode !== document.body) {
      document.body.appendChild(this.els.modal);
    }

    this.unitPrice = this.data.productPrice;
    // Colour and size are both optional: single-option products (socks with
    // only sizes, ties with only colours) and no-option products (pure
    // quantity packs) use '' for the missing dimension in every variant key.
    this.hasColors = this.data.colors.length > 0;
    this.hasSizes = this.data.sizes.length > 0;
    this.generalColor = this.hasColors ? this.firstAvailableColor() : '';
    this.generalSize = this.hasSizes ? this.defaultGeneralSize() : ''; // pre-select the "most bought" size
    this.tierIndex = typeof this.data.defaultTier === 'number' ? this.data.defaultTier : 0;
    this.items = [];
    this.modalItemIndex = null;
    this.syncItems();
    this.restoreState(); // restore the customer's previous selection (if any)

    this.paintSwatches();
    this.bindEvents();
    this.render();
  }

  PackSwitcher.prototype.firstAvailableColor = function () {
    var v = this.data.variants.find(function (x) { return x.available; });
    return v ? v.color : this.data.colors[0];
  };
  PackSwitcher.prototype.firstAvailableSizeFor = function (color) {
    var self = this;
    return this.data.sizes.find(function (s) { return self.isAvailable(color, s); }) || null;
  };
  PackSwitcher.prototype.variantFor = function (color, size) { return this.variantByKey[color + '||' + size]; };
  PackSwitcher.prototype.isAvailable = function (color, size) { var v = this.variantFor(color, size); return !!(v && v.available); };
  PackSwitcher.prototype.colorHasStock = function (color) {
    return this.data.variants.some(function (v) { return v.color === color && v.available; });
  };
  // Size-first: a colour is "available" for the currently chosen general size
  // (struck/blocked otherwise). Falls back to any-stock when no size chosen yet.
  PackSwitcher.prototype.colorAvailable = function (color, size) {
    var s = arguments.length > 1 ? size : this.generalSize;
    return s ? this.isAvailable(color, s) : this.colorHasStock(color);
  };
  PackSwitcher.prototype.currentTier = function () { return this.data.tiers[this.tierIndex]; };
  // An item is fully chosen when every EXISTING dimension has a value; a
  // missing dimension (no colour / no size option) is always satisfied ('').
  PackSwitcher.prototype.itemComplete = function (it) {
    if (this.hasColors && !it.color) return false;
    if (this.hasSizes && !it.size) return false;
    return true;
  };

  // Pre-selected ("most bought") size for this product; the token comes from
  // the Liquid snippet and is matched against the real size options here.
  PackSwitcher.prototype.defaultGeneralSize = function () {
    var token = this.data.defaultSizeToken;
    return token ? matchSizeToken(this.data.sizes, token) : null;
  };

  /* ---- Persistence: remember the customer's selection across reloads ---- */
  PackSwitcher.prototype.storageKey = function () { return 'packSwitcher:' + (this.data.handle || 'product'); };
  PackSwitcher.prototype.saveState = function () {
    try {
      localStorage.setItem(this.storageKey(), JSON.stringify({
        tierIndex: this.tierIndex,
        generalColor: this.generalColor,
        generalSize: this.generalSize,
        items: this.items.map(function (it) { return { color: it.color, size: it.size, custom: !!it.custom }; })
      }));
    } catch (e) {}
  };
  PackSwitcher.prototype.restoreState = function () {
    var raw;
    try { raw = localStorage.getItem(this.storageKey()); } catch (e) { return; }
    if (!raw) return;
    var st; try { st = JSON.parse(raw); } catch (e) { return; }
    if (!st) return;
    var self = this;
    if (typeof st.tierIndex === 'number' && this.data.tiers[st.tierIndex]) this.tierIndex = st.tierIndex;
    if (st.generalColor && this.data.colors.indexOf(st.generalColor) > -1) this.generalColor = st.generalColor;
    if (this.hasSizes && Object.prototype.hasOwnProperty.call(st, 'generalSize')) {
      this.generalSize = (st.generalSize && this.data.sizes.indexOf(st.generalSize) > -1) ? st.generalSize : null;
    }
    this.syncItems(); // correct length for the restored tier, seeded with general values
    if (Array.isArray(st.items)) {
      st.items.slice(0, this.items.length).forEach(function (s, i) {
        if (!s) return;
        if (s.color && self.data.colors.indexOf(s.color) > -1) self.items[i].color = s.color;
        if (s.size && self.data.sizes.indexOf(s.size) > -1) self.items[i].size = s.size;
        self.items[i].custom = !!s.custom;
      });
    }
  };

  PackSwitcher.prototype.syncItems = function () {
    var buy = this.currentTier().buy;
    while (this.items.length < buy) this.items.push({ color: this.generalColor, size: this.generalSize, custom: false });
    if (this.items.length > buy) this.items.length = buy;
  };

  PackSwitcher.prototype.paintSwatches = function () {
    this.root.querySelectorAll('[data-ps-swatch]').forEach(function (el) {
      var name = el.getAttribute('data-ps-swatch');
      el.style.cssText = swatchCss(name);
      if (isPocketColor(name) && !el.firstChild) el.innerHTML = pocketIcon(name);
    });
  };

  PackSwitcher.prototype.bindEvents = function () {
    var self = this;
    if (this.els.sizeSelect) this.els.sizeSelect.addEventListener('change', function () {
      self.generalSize = this.value || null;
      self.items.forEach(function (it) { if (!it.custom) it.size = self.generalSize; });
      self.render();
    });
    if (this.els.colors) this.els.colors.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ps-color]');
      if (!btn || btn.classList.contains('is-unavailable')) return;
      self.generalColor = btn.getAttribute('data-ps-color');
      // Keep the chosen (general) size; do NOT silently swap it. If the combo
      // is sold out the slots are flagged invalid + a note is shown, so the
      // top size and the slots stay consistent.
      self.items.forEach(function (it) { if (!it.custom) it.color = self.generalColor; });
      self.syncGalleryToColor(self.generalColor);
      self.render();
    });
    this.els.tiers.addEventListener('click', function (e) {
      var tier = e.target.closest('[data-ps-tier]');
      if (!tier) return;
      var idx = parseInt(tier.getAttribute('data-ps-tier'), 10);
      if (idx !== self.tierIndex) { self.tierIndex = idx; self.syncItems(); self.render(); }
    });
    if (this.els.slots) this.els.slots.addEventListener('click', function (e) {
      var slot = e.target.closest('[data-ps-edit]');
      if (slot) self.openModal(parseInt(slot.getAttribute('data-ps-edit'), 10));
    });
    if (this.els.modalColors) this.els.modalColors.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ps-mcolor]');
      if (!btn || btn.classList.contains('is-unavailable') || self.modalItemIndex == null) return;
      var item = self.items[self.modalItemIndex];
      item.color = btn.getAttribute('data-ps-mcolor'); item.custom = true;
      if (item.size && !self.isAvailable(item.color, item.size)) {
        self.modalNote = 'La taille ' + item.size + ' est épuisée en ' + item.color + ' – veuillez choisir une autre taille.';
        item.size = null;
      } else {
        self.modalNote = '';
      }
      self.renderModal(); self.render();
    });
    if (this.els.modalSizes) this.els.modalSizes.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-ps-msize-select]');
      if (!sel || self.modalItemIndex == null) return;
      var item = self.items[self.modalItemIndex];
      item.size = sel.value || null; item.custom = true;
      self.modalNote = '';
      self.renderModal(); self.render();
    });
    if (this.els.modal) this.els.modal.querySelectorAll('[data-ps-modal-close]').forEach(function (el) {
      el.addEventListener('click', function () { self.closeModal(); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.closeModal(); });
    this.els.atc.addEventListener('click', function () { self.addToCart(); });
    var sg = this.root.querySelector('[data-ps-sizeguide]');
    if (sg) sg.addEventListener('click', function () { self.openSizeGuide(); });
  };

  // Open the theme's existing SmartSize™ guide (rendered by its Liquid block).
  PackSwitcher.prototype.openSizeGuide = function () {
    if (typeof window.openPopup === 'function') { try { window.openPopup(); return; } catch (e) {} }
    log('SmartSize openPopup() not found on page');
  };

  // Apply the guide result to the general size dropdown. Different products use
  // different guides with different result formats: the shirt guide outputs
  // "41 (S)" while e.g. the pants guide outputs a bare token like "L" or "2XL".
  // Reuse the same fuzzy token matcher as the size defaults so both formats resolve.
  PackSwitcher.prototype.applyGuideSize = function (sizeStr) {
    if (!sizeStr) return;
    var match = matchSizeToken(this.data.sizes, sizeStr);
    if (!match) { log('guide size not found in options:', sizeStr); return; }
    if (match === this.generalSize) return;
    var self = this;
    this.generalSize = match;
    this.items.forEach(function (it) { if (!it.custom) it.size = self.generalSize; });
    this.render();
    log('applied guide size:', match);
  };

  // Drive the (hidden) native colour radio so the theme's gallery shows the
  // matching colour image. Only used for the main/general colour switcher.
  PackSwitcher.prototype.syncGalleryToColor = function (color) {
    try {
      // The theme's cro-bundle-size-defaults.liquid freezes the gallery (it
      // overrides setActiveMedia until the shopper touches the native gallery).
      // Our switcher isn't in its release list, so restore the real
      // setActiveMedia right before we switch the image (it re-freezes after).
      document.querySelectorAll('media-gallery, media-gallery-mobile').forEach(function (g) {
        if (g.__abFroze && g.__abOrig) { g.setActiveMedia = g.__abOrig; g.__abFroze = false; }
      });
      var picker = document.querySelector('[data-variant-picker]') || document.querySelector('variant-selects, .m-product-variants') || document;
      // The colour option is named per store language: Color / Colour / Farbe /
      // Couleur. Match the radio whose VALUE equals the chosen colour, whatever
      // its name — then fall back to a <select> option.
      var radios = picker.querySelectorAll('input[type="radio"]');
      var input = null;
      for (var i = 0; i < radios.length; i++) { if (radios[i].value === color) { input = radios[i]; break; } }
      if (input) {
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
      var selects = picker.querySelectorAll('select');
      for (var j = 0; j < selects.length; j++) {
        var sel = selects[j], has = false;
        for (var k = 0; k < sel.options.length; k++) { if (sel.options[k].value === color) { has = true; break; } }
        if (has && sel.value !== color) {
          sel.value = color;
          sel.dispatchEvent(new Event('input', { bubbles: true }));
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
    } catch (e) {}
  };

  PackSwitcher.prototype.render = function () {
    var self = this;
    if (this.els.sizeSelect) {
      this.els.sizeSelect.value = this.generalSize || '';
      Array.prototype.forEach.call(this.els.sizeSelect.options, function (opt) {
        if (!opt.value) return;
        var anyAvail = self.data.variants.some(function (v) { return v.size === opt.value && v.available; });
        opt.disabled = !anyAvail;
      });
    }
    if (this.els.colorCurrent) this.els.colorCurrent.textContent = this.generalColor || 'Choisir la couleur.';
    if (this.els.colors) this.els.colors.querySelectorAll('[data-ps-color]').forEach(function (btn) {
      var color = btn.getAttribute('data-ps-color');
      btn.classList.toggle('is-selected', color === self.generalColor);
      btn.classList.toggle('is-unavailable', !self.colorAvailable(color));
    });
    this.els.qty.textContent = this.currentTier().buy;
    this.renderTiers();
    this.renderSlots();
    this.renderPerks();
    this.renderTotal();
    this.saveState();
  };

  PackSwitcher.prototype.renderTiers = function () {
    var self = this;
    this.els.tiers.style.gridTemplateColumns = 'repeat(' + this.data.tiers.length + ', minmax(0, 1fr))';
    this.els.tiers.classList.toggle('ps-tiers--cadeau-bas', this.data.tiers.some(function (t) { return t.badgeGift; }));
    this.els.tiers.innerHTML = this.data.tiers.map(function (tier, ti) {
      var selected = ti === self.tierIndex;
      var free = tier.buy - tier.pay;
      var h = '<button type="button" class="ps-tier' + (selected ? ' is-selected' : '') + '" data-ps-tier="' + ti + '">';
      if (tier.badge) h += '<span class="ps-tier__badge' + (tier.badgeGift ? ' ps-tier__badge--gift' : '') + '">' + (tier.badgeGift ? '<span class="ps-badge__plus">+</span>' : '') + escapeHtml(tier.badge) + (tier.badgeGift ? ICON_GIFT : '') + '</span>';
      h += '<span class="ps-tier__name">' + escapeHtml(tier.name) + '</span>';
      h += '<span class="ps-tier__sub' + (free > 0 ? ' ps-tier__sub--save' : '') + '">' + escapeHtml(tier.sub) + '</span>';
      h += self.tierPerkHtml(tier);
      h += '</button>';
      return h;
    }).join('');
  };

  PackSwitcher.prototype.renderSlots = function () {
    var self = this;
    if (!this.els.slots) return; // quantity-only products have no per-item slots
    var buy = this.currentTier().buy;
    if (buy <= 1) { this.els.slots.innerHTML = ''; return; }
    var pay = this.currentTier().pay;
    this.els.slots.innerHTML = this.items.map(function (item, i) {
      var complete = self.itemComplete(item);
      var soldOut = complete && !self.isAvailable(item.color, item.size);
      var valid = complete && !soldOut;
      var isFree = i >= pay;
      var parts = [];
      if (self.hasColors) parts.push(escapeHtml(item.color || 'Couleur ?'));
      if (self.hasSizes) parts.push(escapeHtml(item.size || 'Taille ?'));
      return '<button type="button" class="ps-slot' + (valid ? '' : ' is-invalid') + (isFree ? ' is-free' : '') + '" data-ps-edit="' + i + '">' +
        '<span class="ps-slot__index">' + (i + 1) + '</span>' +
        (self.hasColors ? '<span class="ps-slot__swatch" style="' + swatchCss(item.color) + '">' + swatchInner(item.color) + '</span>' : '') +
        '<span class="ps-slot__text">' + parts.join(' · ') +
        (soldOut ? ' <span class="ps-slot__warn">indisponible</span>' : '') + '</span>' +
        (isFree ? '<span class="ps-slot__badge">Offert</span>' : '') +
        '<span class="ps-slot__edit">Modifier</span></button>';
    }).join('');
  };

  /* ---- Cadeau et livraison offerts (maquette du 16/10/2026) : affichage seulement ---- */
  // Prix du pack, même calcul que renderTotal (montant fixe, puis %, puis pièces payées).
  PackSwitcher.prototype.tierPrice = function (tier) {
    var regular = tier.buy * this.unitPrice;
    if (tier.amountOff > 0) {
      var rate = 1;
      if (this.data.shopCurrency && this.data.shopCurrency !== this.data.currency &&
          window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
        rate = parseFloat(window.Shopify.currency.rate) || 1;
      }
      return Math.max(0, regular - Math.round(tier.amountOff * rate));
    }
    if (tier.percent > 0) return Math.round(regular * (1 - tier.percent / 100));
    return tier.pay * this.unitPrice;
  };
  // Livraison offerte quand le prix du pack atteint le seuil de la boutique (80 € en France).
  PackSwitcher.prototype.shipFree = function (tier) {
    var s = this.data.ship;
    return !!(s && s.enabled && this.tierPrice(tier) >= (s.freeFrom || 0));
  };
  // « + livraison 4,90 € » seulement si un des packs de la fiche atteint le seuil (Tom, 17/10).
  PackSwitcher.prototype.anyShipFree = function () {
    var self = this;
    return (this.data.tiers || []).some(function (t) { return self.shipFree(t); });
  };
  PackSwitcher.prototype.tierPerkHtml = function (tier) {
    var s = this.data.ship;
    if (!s || !s.enabled) return '';
    if (this.shipFree(tier)) return '<span class="ps-tier__perk"><span class="ps-tier__plus">+</span>Livraison offerte' + ICON_TRUCK + '</span>';
    if (s.showPaid && s.price && this.anyShipFree()) return '<span class="ps-tier__perk ps-tier__perk--paid">+ livraison ' + escapeHtml(s.price) + '</span>';
    return '';
  };
  // Encadré sous les pièces du pack : livraison offerte, puis cadeau (comme la fiche Fincut).
  PackSwitcher.prototype.renderPerks = function () {
    if (!this.els.perks) return;
    var tier = this.currentTier(), s = this.data.ship, g = this.data.gift, rows = [];
    if (s && s.enabled && this.shipFree(tier)) {
      rows.push('<div class="ps-perk ps-perk--ship">' +
        '<span class="ps-perk__media ps-perk__media--icon">' + ICON_TRUCK + '</span>' +
        '<span class="ps-perk__text"><span class="ps-perk__title">Livraison à domicile</span></span>' +
        '<span class="ps-perk__price">' + (s.price ? '<s>' + escapeHtml(s.price) + '</s>' : '') +
        '<span class="ps-perk__badge">Offerte</span></span></div>');
    }
    if (g && tier.gift) {
      rows.push('<div class="ps-perk ps-perk--gift">' +
        (g.image ? '<span class="ps-perk__media"><img src="' + escapeHtml(g.image) + '" alt="" width="64" height="64" loading="lazy">' +
          '<span class="ps-perk__tag">' + ICON_GIFT + '</span></span>'
          : '<span class="ps-perk__media ps-perk__media--icon">' + ICON_GIFT + '</span>') +
        '<span class="ps-perk__text"><span class="ps-perk__title">' + escapeHtml(g.title) + '</span>' +
        (g.detail ? '<span class="ps-perk__detail">' + escapeHtml(g.detail) + '</span>' : '') + '</span>' +
        '<span class="ps-perk__price"><s>' + formatMoney(g.price, this.data.currency) + '</s>' +
        '<span class="ps-perk__badge">' + escapeHtml(g.freeWord || 'Offert') + '</span></span></div>');
    }
    this.els.perks.innerHTML = rows.join('');
    this.els.perks.hidden = rows.length === 0;
  };

  PackSwitcher.prototype.renderTotal = function () {
    var tier = this.currentTier();
    var regular = tier.buy * this.unitPrice;
    // Bundle price, by priority: fixed amount off (e.g. "-10 €" — defined
    // in the shop's base currency, converted via Shopify's published rate
    // when another currency is presented), then percent discount, then
    // "items paid x unit price" (free-item tiers).
    var bundle;
    if (tier.amountOff > 0) {
      var rate = 1;
      if (this.data.shopCurrency && this.data.shopCurrency !== this.data.currency &&
          window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
        rate = parseFloat(window.Shopify.currency.rate) || 1;
      }
      bundle = Math.max(0, regular - Math.round(tier.amountOff * rate));
    } else if (tier.percent > 0) {
      bundle = Math.round(regular * (1 - tier.percent / 100));
    } else {
      bundle = tier.pay * this.unitPrice;
    }
    var save = regular > 0 ? Math.round((1 - bundle / regular) * 100) : 0;
    this.els.total.textContent = formatMoney(bundle, this.data.currency);
    this.els.totalWas.textContent = save > 0 ? formatMoney(regular, this.data.currency) : '';
    this.els.totalSave.textContent = save > 0 ? ('Économisez ' + save + ' %') : '';
    if (this.els.perunit) {
      this.els.perunit.textContent = tier.buy > 1 ? (formatMoney(bundle / tier.buy, this.data.currency) + ' par pièce') : '';
    }
    var allValid = this.items.length > 0 && this.items.every(function (it) {
      return this.itemComplete(it) && this.isAvailable(it.color, it.size);
    }, this);
    this.els.atc.disabled = !allValid;

    // Persistent note when a fully chosen combination is sold out. Wording
    // adapts to which dimensions the product actually has.
    var soldOut = null;
    this.items.forEach(function (it) {
      if (!soldOut && this.itemComplete(it) && !this.isAvailable(it.color, it.size)) soldOut = it;
    }, this);
    var msg = '';
    if (soldOut) {
      if (this.hasColors && this.hasSizes) {
        msg = soldOut.color + ' est épuisé en taille ' + soldOut.size + ' – veuillez choisir une autre taille ou couleur.';
      } else if (this.hasSizes) {
        msg = 'La taille ' + soldOut.size + ' est épuisée – veuillez choisir une autre taille.';
      } else if (this.hasColors) {
        msg = soldOut.color + ' est épuisé – veuillez choisir une autre couleur.';
      } else {
        msg = 'Cet article est épuisé.';
      }
    }
    this.showMessage(msg);
  };

  PackSwitcher.prototype.openModal = function (i) {
    if (!this.els.modal) return;
    this.modalItemIndex = i;
    this.modalNote = '';
    this.els.modalTitle.textContent = 'Personnaliser l’article ' + (i + 1);
    this.renderModal();
    // Preserve scroll position: showing the (fixed) modal must not jump the page.
    var sy = window.pageYOffset || document.documentElement.scrollTop || 0;
    this.els.modal.hidden = false;
    if ((window.pageYOffset || 0) !== sy) window.scrollTo(0, sy);
    requestAnimationFrame(function () { if ((window.pageYOffset || 0) !== sy) window.scrollTo(0, sy); });
  };

  PackSwitcher.prototype.renderModal = function () {
    if (this.modalItemIndex == null || !this.els.modal) return;
    var self = this;
    var item = this.items[this.modalItemIndex];
    var cur = this.els.modal.querySelector('[data-ps-modal-color-current]');
    if (cur) cur.textContent = item.color || '';
    if (this.els.modalColors) this.els.modalColors.innerHTML = this.data.colors.map(function (color) {
      var avail = self.colorAvailable(color, item.size);
      var selected = color === item.color;
      // Inline styles with !important so other theme CSS can't strip them.
      var sw = 'width:30px;height:30px;border-radius:50%;display:flex;align-items:center;justify-content:center;border:1px solid rgba(0,0,0,.18);' + swatchCss(color);
      if (!avail) sw += 'background-image:linear-gradient(to bottom right, transparent 47%, #c0392b 47%, #c0392b 53%, transparent 53%) !important;';
      if (selected) sw += 'box-shadow:0 0 0 2px #fff,0 0 0 3px #111 !important;';
      var cls = 'ps-color' + (isPocketColor(color) ? ' ps-color--pocket' : '') + (selected ? ' is-selected' : '') + (avail ? '' : ' is-unavailable');
      return '<button type="button" class="' + cls + '" data-ps-mcolor="' + escapeHtml(color) + '" title="' + escapeHtml(color) + '">' +
        '<span class="ps-color__swatch" style="' + sw + '">' + swatchInner(color) + '</span></button>';
    }).join('');
    var noteEl = this.els.modal.querySelector('[data-ps-modal-note]');
    if (noteEl) noteEl.textContent = this.modalNote || '';
    if (this.els.modalSizes) {
      var opts = '<option value="" disabled' + (item.size ? '' : ' selected') + '>Choisir la taille</option>';
      opts += this.data.sizes.map(function (size) {
        var avail2 = self.isAvailable(item.color, size);
        return '<option value="' + escapeHtml(size) + '"' + (size === item.size ? ' selected' : '') + (avail2 ? '' : ' disabled') + '>' + escapeHtml(size) + '</option>';
      }).join('');
      var selStyle = 'width:100%;height:48px;padding:0 38px 0 14px;font-size:15px;color:#111;cursor:pointer;' +
        'border:1px solid #d9d9d9 !important;border-radius:9px !important;background:#fff !important;' +
        '-webkit-appearance:none !important;-moz-appearance:none !important;appearance:none !important;box-shadow:none !important;';
      this.els.modalSizes.innerHTML = '<div class="ps-selectwrap"><select class="ps-select" style="' + selStyle + '" data-ps-msize-select>' + opts + '</select></div>';
    }
  };

  PackSwitcher.prototype.closeModal = function () {
    this.modalItemIndex = null;
    if (this.els.modal) this.els.modal.hidden = true;
  };

  PackSwitcher.prototype.showMessage = function (msg) {
    this.els.message.textContent = msg || '';
    this.els.message.classList.toggle('is-visible', !!msg);
  };
  PackSwitcher.prototype.setLoading = function (loading) {
    this.els.atc.disabled = loading;
    if (this.els.atcSpinner) this.els.atcSpinner.hidden = !loading;
  };

  PackSwitcher.prototype.addToCart = function () {
    var self = this;
    this.showMessage('');
    if (this.hasSizes && !this.generalSize && this.items.some(function (it) { return !it.size; })) {
      this.showMessage('Veuillez d’abord choisir une taille.'); return;
    }
    var byVariant = {}, invalid = false;
    this.items.forEach(function (item) {
      var v = self.variantFor(item.color, item.size);
      if (!v || !v.available) { invalid = true; return; }
      byVariant[v.id] = (byVariant[v.id] || 0) + 1;
    });
    if (invalid) { this.showMessage('Veuillez choisir une couleur et une taille disponibles pour chaque article.'); return; }
    // One cart line per piece: identical pieces sharing a line get split in two by the 2+1 discount, and changing the colour of one part in the Kaching cart changed the whole line.
    var pack = Date.now().toString(36), items = []; Object.keys(byVariant).forEach(function (id) { for (var k = 0; k < byVariant[id]; k++) items.push({ id: parseInt(id, 10), quantity: 1, properties: { _pack_item: pack + '-' + items.length } }); });

    var routes = (window.MinimogSettings && window.MinimogSettings.routes) || (window.Shopify && window.Shopify.routes) || {};
    var addUrl = routes.cart_add_url || '/cart/add.js';
    var discountCode = (this.currentTier().discountCode || '').trim();

    this.setLoading(true);
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (res) { return res.json(); })
      .then(function (response) {
        if (response.status) { self.showMessage(response.description || response.message || 'Erreur lors de l’ajout.'); self.setLoading(false); return; }
        if (discountCode) { window.location.href = '/discount/' + encodeURIComponent(discountCode) + '?redirect=/cart'; return; }
        self.refreshCartCount();
        var drawer = document.querySelector('m-cart-drawer');
        var hasEvents = window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents;
        if (drawer && response.sections && typeof drawer.renderContents === 'function') {
          // Same path as the theme's own product form: re-render + open drawer.
          drawer.renderContents(response);
          if (hasEvents) window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, response);
        } else if (hasEvents) {
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, response);
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.openCartDrawer, response);
        } else {
          window.location = (routes.cart_url || '/cart');
          return;
        }
        self.setLoading(false);
      })
      .catch(function () { self.showMessage('Une erreur s’est produite. Veuillez réessayer.'); self.setLoading(false); });
  };

  PackSwitcher.prototype.refreshCartCount = function () {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.json', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart) return;
        var count = cart.item_count;
        document.querySelectorAll('.m-cart-count-bubble').forEach(function (el) {
          if (count > 0) { el.textContent = count; el.classList.remove('m:hidden'); el.classList.remove('hidden'); }
          else { el.classList.add('m:hidden'); }
        });
      }).catch(function () {});
  };

  /* --------------------------- BOOTSTRAP ---------------------------- */
  var lastInstance = null;

  // Watch the SmartSize™ guide's result (#result-text, filled by its own JS)
  // and apply it to our size dropdown. Done via the DOM because the guide stores
  // its result in a script-scoped `let` (not on window), so it can't be read.
  function hookSizeGuide() {
    if (window.__psGuideHooked) return;
    var tries = 0;
    (function tryObserve() {
      var el = document.getElementById('result-text') ||
               (document.getElementById('result') || document).querySelector('#result-text');
      if (!el) { if (tries++ < 40) setTimeout(tryObserve, 200); return; }
      window.__psGuideHooked = true;
      var apply = function () {
        try {
          var t = (el.textContent || '').trim();
          // Different guides format the result differently: shirt = "44 (XL)",
          // pants = a bare token like "L" or "2XL". Just require a short,
          // non-empty result; applyGuideSize()'s own matching validates it.
          if (lastInstance && t && t.length <= 20) lastInstance.applyGuideSize(t);
        } catch (e) {}
      };
      new MutationObserver(apply).observe(el, { childList: true, characterData: true, subtree: true });
      apply(); // in case a result is already present
      log('SmartSize result observer installed');
    })();
  }

  function boot() {
    document.querySelectorAll('pack-switcher[data-pack-switcher]').forEach(function (root) {
      if (root.hasAttribute('data-ps-init')) return;
      var dataEl = root.querySelector('script[data-pack-switcher-data]');
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { log('invalid data JSON', e); return; }
      if (!data || !Array.isArray(data.variants) || !data.variants.length) return;
      root.setAttribute('data-ps-init', '1');
      lastInstance = new PackSwitcher(root, data);
      hookSizeGuide();
      log('boot, handle:', data.handle);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
